/* eslint-disable @typescript-eslint/naming-convention */
export interface IQuickActionRaw {
  id: string;
  title: string;
  icon?: string;
  description: string;
  domain: string;
  default_message: string;
  tags: string[];
}

export interface IQuickActionDomainRaw {
  id: string;
  name: string;
  description: string;
  actions: IQuickActionRaw[];
}

export interface IQuickActionsResponseRaw {
  version: string;
  domains: IQuickActionDomainRaw[];
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IQuickAction {
  id: string;
  title: string;
  icon?: string;
  description: string;
  domain: string;
  defaultMessage: string;
  tags: string[];
}

export interface IQuickActionDomain {
  id: string;
  name: string;
  description: string;
  actions: IQuickAction[];
}

export interface IQuickActionsResponse {
  version: string;
  domains: IQuickActionDomain[];
}

export const MAX_QUICK_ACTION_ID_LENGTH = 96;

const toQuickAction = (raw: IQuickActionRaw): IQuickAction => ({
  id: raw.id,
  title: raw.title,
  icon: raw.icon,
  description: raw.description,
  domain: raw.domain,
  defaultMessage: raw.default_message,
  tags: raw.tags ?? []
});

const toQuickActionDomain = (raw: IQuickActionDomainRaw): IQuickActionDomain => ({
  id: raw.id,
  name: raw.name,
  description: raw.description,
  actions: (raw.actions ?? []).map(toQuickAction)
});

export const toQuickActionsResponse = (raw: IQuickActionsResponseRaw): IQuickActionsResponse => ({
  version: raw.version,
  domains: (raw.domains ?? []).map(toQuickActionDomain)
});
